export default __webpack_public_path__ + "static/media/fifa-prediction.66ffc655.webp";